import { Helmet } from 'react-helmet';

export type SeoAlternate = { hrefLang: string; href: string };

type SeoHeadProps = {
  title: string;
  description?: string;
  keywords?: string;
  canonical: string;
  alternates: SeoAlternate[];
  image: string;
  locale: string;
  alternateLocale: string;
  type: 'website' | 'product';
  jsonLd: Record<string, unknown>;
};

const SeoHead = ({
  title,
  description,
  keywords,
  canonical,
  alternates,
  image,
  locale,
  alternateLocale,
  type,
  jsonLd,
}: SeoHeadProps) => (
  <Helmet>
    <title>{title}</title>
    {description ? <meta name='description' content={description} /> : null}
    {keywords ? <meta name='keywords' content={keywords} /> : null}
    <link rel='canonical' href={canonical} />
    {alternates.map((alt) => (
      <link
        key={alt.hrefLang}
        rel='alternate'
        hrefLang={alt.hrefLang}
        href={alt.href}
      />
    ))}
    <meta property='og:type' content={type} />
    <meta property='og:title' content={title} />
    {description ? (
      <meta property='og:description' content={description} />
    ) : null}
    <meta property='og:url' content={canonical} />
    <meta property='og:image' content={image} />
    <meta property='og:locale' content={locale} />
    <meta property='og:locale:alternate' content={alternateLocale} />
    <meta name='twitter:card' content='summary_large_image' />
    <meta name='twitter:title' content={title} />
    {description ? (
      <meta name='twitter:description' content={description} />
    ) : null}
    <meta name='twitter:image' content={image} />
    <script type='application/ld+json'>
      {JSON.stringify(jsonLd).replace(/</g, '\\u003c')}
    </script>
  </Helmet>
);

export default SeoHead;
